import { createModule } from "ng";
import "emun.payments/startup";
import payments from "emun.payments/payments.module";

export const app = createModule("emun.payments", payments);
console.warn("Loaded Emun.Payments Module:", { payments, app });

export default app.name;
